import { PROPERTY_CALC_FIELDS, type CalculationAssumptions } from '@brimo/shared';
import { TextField } from '../../../ds/components';
import { organizationHint, type CalcDefaultsDraft, type CalcDefaultsKey } from './calcDefaultsDraft';
import dialogStyles from './dialogs.module.css';

/**
 * One group of „Objekt-Vorgaben" fields (D-361/D-362): used by the sheet „Objekt-Vorgaben" (all groups) and by the
 * base-data sheet (group „Kalkulation" with the eight calculation fields). Every calculation field shows the
 * organization's value as a muted hint.
 */
export interface CalcDefaultsFieldsProps {
  title: string;
  keys: readonly CalcDefaultsKey[];
  draft: CalcDefaultsDraft;
  /** Field errors keyed `calcDefaults.<key>`. */
  fields: Record<string, string>;
  /** The organization's assumptions in force; null when the user may not read them. */
  org: CalculationAssumptions | null;
  /** Marks the fields as required (base data, D-362). */
  required?: boolean | undefined;
  onChange: (key: CalcDefaultsKey, value: string) => void;
}

export function CalcDefaultsFields({
  title,
  keys,
  draft,
  fields,
  org,
  required,
  onChange,
}: CalcDefaultsFieldsProps) {
  return (
    <div className={dialogStyles.group}>
      <div className={dialogStyles.groupTitle}>{title}</div>
      <div className={dialogStyles.grid2}>
        {keys.map((key) => {
          const spec = PROPERTY_CALC_FIELDS[key];
          const hint = organizationHint(key, org);
          return (
            <TextField
              key={key}
              label={spec.label}
              required={required}
              optional={!required}
              inputMode="decimal"
              trailing={<span className={dialogStyles.suffix}>{spec.suffix}</span>}
              value={draft[key]}
              error={fields[`calcDefaults.${key}`]}
              {...(hint === undefined ? {} : { hint })}
              onChange={(event) => onChange(key, event.target.value)}
            />
          );
        })}
      </div>
    </div>
  );
}
